import SignInIndex from "./Screens/SignIn/Index";
import SignIn from "./Screens/SignIn/SignIn";

import Activate from "./Screens/ActivateMaxicareCard/Index";
import ActivateChooseMembership from "./Screens/ActivateMaxicareCard/ActivateChooseMembership";
import ActivateCardFlow from "./Screens/ActivateMaxicareCard/ActivateCardFlow";
import ActivateCorpCodeFlow from "./Screens/ActivateMaxicareCard/ActivateCorpCodeFlow";
import ActivateVerifyOTP from "./Screens/ActivateMaxicareCard/ActivateVerifyOTP";
import ActivateSuccess from "./Screens/ActivateMaxicareCard/ActivateSuccess";
import CardDetailsDelivery from "./Screens/ActivateMaxicareCard/CardDetailsDelivery";
import OTPVerifyCardDetails from "./Screens/ActivateMaxicareCard/OTPVerifyCardDetails";
import CardSuccess from "./Screens/ActivateMaxicareCard/CardSuccess";

import LOAReimbursementIndex from "./Screens/LOAReimbursement/Index";
import LOAReimbursement from "./Screens/LOAReimbursement/LOAReimbursement";
import LoaConsultIndex from "./Screens/LOAReimbursement/ConsultationRequest/Index";
import LoaConsult from "./Screens/LOAReimbursement/ConsultationRequest/LoaConsult";
import LoaMedicalTestIndex from "./Screens/LOAReimbursement/MedicalRequest/Index";
import LoaMedicalTest from "./Screens/LOAReimbursement/MedicalRequest/LoaMedicalTest";
import ReimbursementRequestIndex from "./Screens/LOAReimbursement/ReimbursementRequest/Index";
import ReimbursementRequest from "./Screens/LOAReimbursement/ReimbursementRequest/ReimbursementRequest";

import ConsultDoctor from "./Screens/ConsultDoctorScreen/Index";
import StepOne from "./Screens/ConsultDoctorScreen/1_step";
import StepTwo from "./Screens/ConsultDoctorScreen/2_step";
import StepThree from "./Screens/ConsultDoctorScreen/3_step";
import StepFour from "./Screens/ConsultDoctorScreen/4_step";
import StepFiveSuccess from "./Screens/ConsultDoctorScreen/5_success";

import RequestMedicalTest from "./Screens/RequestMedicalScreen/Index";
import ReqMedical1 from "./Screens/RequestMedicalScreen/1_step";
import ReqMedical2 from "./Screens/RequestMedicalScreen/2_step";
import ReqMedical3 from "./Screens/RequestMedicalScreen/3_step";
import ReqMedical4 from "./Screens/RequestMedicalScreen/4_step";

import RecoveryAccount from "./Screens/AccountRecovery/Index";
import RecoveryHotline from "./Screens/AccountRecovery/RecoveryHotline";
import RecoveryOptions from "./Screens/AccountRecovery/RecoveryOptions";
import EmailAddress from "./Screens/AccountRecovery/EmailAddress/EmailAddress";
import EmailVerifyOTP from "./Screens/AccountRecovery/EmailAddress/EmailVerifyOTP";
import EmailOldNumber from "./Screens/AccountRecovery/EmailAddress/EmailOldNumber";
import EmailNewNumber from "./Screens/AccountRecovery/EmailAddress/EmailNewNumber";
import EmailVerifyOTPNewNumber from "./Screens/AccountRecovery/EmailAddress/EmailVerifyOTPNewNumber";
import EmailSuccess from "./Screens/AccountRecovery/EmailAddress/EmailSuccess";

import MaxicareCard from "./Screens/AccountRecovery/MaxicareCard/MaxicareCard";
import MaxicareCardPersonalInfo from "./Screens/AccountRecovery/MaxicareCard/MaxicareCardPersonalInfo";
import MaxicareCardOldNumber from "./Screens/AccountRecovery/MaxicareCard/MaxicareCardOldNumber";
import MaxicareCardNewNumber from "./Screens/AccountRecovery/MaxicareCard/MaxicareCardNewNumber";
import MaxicareCardVerifyOTP from "./Screens/AccountRecovery/MaxicareCard/MaxicareCardVerifyOTP";
import MaxicareCardSuccess from "./Screens/AccountRecovery/MaxicareCard/MaxicareCardSuccess";

import { BottomNavBar, SideDrawer } from "./Components/Drawer";
import DashboardIndex from "./Screens/Dashboard/Index";
import Dashboard from "./Screens/Dashboard/Dashboard";

import AddPolicyOTP from "./Screens/AddPolicy/3_AddPolicyOTP";
import ReviewCard from "./Screens/AddPolicy/4_ReviewCard";
import PolicySuccess from "./Screens/AddPolicy/5_PolicySuccess";
import PoliciesDetails from "./Screens/Policies/PoliciesDetails";
import AddCard from "./Screens/AddPolicy/2_AddCard";

import ReqMedical5 from "./Screens/RequestMedicalScreen/5_step";
import ReqMedical6 from "./Screens/RequestMedicalScreen/6_step";
import ReqMedical7 from "./Screens/RequestMedicalScreen/7_step";
import ReqMedicalSuccess from "./Screens/RequestMedicalScreen/8_step";

import LoginIndex from "./Screens/Login/Index";
import Login from "./Screens/Login/Login";
import LoginVerifyOTP from "./Screens/Login/LoginVerifyOTP";
import LoginAccountLocked from "./Screens/Login/LoginAccountLocked";

import { useAuth } from "./Contexts/AuthContext";

import { Routes, Route } from "react-router-dom";
import SplashScreen from "./Screens/Splash/Splash";

import Policies from "./Screens/Policies/Policies";
import AddPolicy from "./Screens/AddPolicy/Index";
import ChooseMembership from "./Screens/AddPolicy/1_ChooseMembership";
import MyAccountIndex from "./Screens/MyAccount/Index";
import MyAccount from "./Screens/MyAccount/MyAccount";

import Teleconsult from "./Screens/Teleconsult/Index";
import TeleconsultInstructions from "./Screens/Teleconsult/TeleconsultInstructions";
import TeleconsultLandlineNumber from "./Screens/Teleconsult/TeleconsultLandlineNumber";

import Tracker from "./Screens/Tracker/Index";
import Appointments from "./Screens/Tracker/AllAppointments";
import MedicalTests from "./Screens/Tracker/AllMedicalTestResults";

import TransactionHistoryIndex from "./Screens/TransactionHistory/Index";
import TransactionHistory from "./Screens/TransactionHistory/Transactions";

import UpdateDetails from "./Screens/MyAccount/Details";
import UpdateDetailsOTP from "./Screens/MyAccount/Otp";
import UpdateDetailsSuccess from "./Screens/MyAccount/Success";

import Notification from "./Screens/Notification/Index";
import NotificationList from "./Screens/Notification/List";
import NotificationDetails from "./Screens/Notification/Details";

import BookServiceIndex from "./Screens/BookService/Index";
import BookService from "./Screens/BookService/BookService";

import VerificationIndex from "./Screens/Verification/Index";
import Verification from "./Screens/Verification/Verification";

import VerifyEmailIndex from "./Screens/VerifyEmail/Index";
import VerifyEmail from "./Screens/VerifyEmail/Verify";

const App = () => {
  const { showSplashscreen } = useAuth();

  return (
    <>
      {showSplashscreen ? (
        <SplashScreen />
      ) : (
        <Routes>
          <Route path="/" element={<SignInIndex />}>
            <Route index element={<SignIn />} />
          </Route>
          <Route path="/home" element={<DashboardIndex />}>
            <Route index element={<Dashboard />} />
          </Route>
          <Route path="/activate" element={<Activate />}>
            <Route index element={<ActivateChooseMembership />} />
            <Route
              path="/activate/choose-membership"
              element={<ActivateChooseMembership />}
            />
            <Route
              path="/activate/membership/activate-card/maxicare-card"
              element={<ActivateCardFlow />}
            />
            <Route
              path="/activate/membership/activate-card/corporate-code"
              element={<ActivateCorpCodeFlow />}
            />
            <Route
              path="/activate/verify-otp"
              element={<ActivateVerifyOTP />}
            />
            <Route path="/activate/success" element={<ActivateSuccess />} />
            <Route
              path="/activate/card-delivery"
              element={<CardDetailsDelivery />}
            />
            <Route
              path="/activate/card-delivery/verify-otp"
              element={<OTPVerifyCardDetails />}
            />
            <Route path="/activate/details-success" element={<CardSuccess />} />
          </Route>
          <Route path="/login" element={<LoginIndex />}>
            <Route index element={<Login />} />
            <Route path="/login/verify-otp" element={<LoginVerifyOTP />} />
            <Route
              path="/login/account-locked"
              element={<LoginAccountLocked />}
            />
          </Route>
          <Route path="/tracker" element={<Tracker />}>
            <Route index element={<Appointments />} />
            <Route path="/tracker/appointments" element={<Appointments />} />
            <Route path="/tracker/medical-tests" element={<MedicalTests />} />
          </Route>
          <Route path="/consult-doctor" element={<ConsultDoctor />}>
            <Route index element={<StepOne />} />
            <Route path="/consult-doctor/choose-policy" element={<StepOne />} />
            <Route path="/consult-doctor/choose-clinic" element={<StepTwo />} />
            <Route
              path="/consult-doctor/choose-date-time"
              element={<StepThree />}
            />
            <Route
              path="/consult-doctor/booking-summary"
              element={<StepFour />}
            />
            <Route
              path="/consult-doctor/success"
              element={<StepFiveSuccess />}
            />
          </Route>
          <Route path="/request-medical-test" element={<RequestMedicalTest />}>
            <Route index element={<ReqMedical1 />} />
            <Route
              path="/request-medical-test/policy"
              element={<ReqMedical1 />}
            />
            <Route
              path="/request-medical-test/diagnostic-order"
              element={<ReqMedical2 />}
            />
            <Route
              path="/request-medical-test/procedure"
              element={<ReqMedical3 />}
            />
            <Route
              path="/request-medical-test/choose-clinic"
              element={<ReqMedical4 />}
            />
            <Route
              path="/request-medical-test/choose-date-time"
              element={<ReqMedical5 />}
            />
            <Route
              path="/request-medical-test/booking-summary"
              element={<ReqMedical6 />}
            />
            <Route
              path="/request-medical-test/verify-otp"
              element={<ReqMedical7 />}
            />
            <Route
              path="/request-medical-test/success"
              element={<ReqMedicalSuccess />}
            />
          </Route>
          <Route path="/recovery-account" element={<RecoveryAccount />}>
            <Route index element={<RecoveryOptions />} />
            <Route
              path="/recovery-account/email-address"
              element={<EmailAddress />}
            />
            <Route
              path="/recovery-account/email-address/verify-otp"
              element={<EmailVerifyOTP />}
            />
            <Route
              path="/recovery-account/old-number"
              element={<EmailOldNumber />}
            />
            <Route
              path="/recovery-account/new-number"
              element={<EmailNewNumber />}
            />
            <Route
              path="/recovery-account/new-number/verify-otp"
              element={<EmailVerifyOTPNewNumber />}
            />
            <Route
              path="/recovery-account/success"
              element={<EmailSuccess />}
            />
            <Route
              path="/recovery-account/maxicare-card-number"
              element={<MaxicareCard />}
            />
            <Route
              path="/recovery-account/maxicare-card-number/personal-information"
              element={<MaxicareCardPersonalInfo />}
            />
            <Route
              path="/recovery-account/maxicare-card-number/old-number"
              element={<MaxicareCardOldNumber />}
            />
            <Route
              path="/recovery-account/maxicare-card-number/new-number"
              element={<MaxicareCardNewNumber />}
            />
            <Route
              path="/recovery-account/maxicare-card-number/new-number/verify-otp"
              element={<MaxicareCardVerifyOTP />}
            />
            <Route
              path="/recovery-account/maxicare-card-number/success"
              element={<MaxicareCardSuccess />}
            />
            <Route
              path="/recovery-account/hotline"
              element={<RecoveryHotline />}
            />
            <Route
              path="/recovery-account/options"
              element={<RecoveryOptions />}
            />
          </Route>
          <Route path="/add-policy" element={<AddPolicy />}>
            <Route
              index
              element={
                <>
                  <SideDrawer>
                    <Policies />
                  </SideDrawer>
                  <BottomNavBar />
                </>
              }
            />
            <Route
              path="/add-policy/choose-membership"
              element={<ChooseMembership />}
            />
            <Route path="/add-policy/card-number" element={<AddCard />} />
            <Route
              path="/add-policy/card-number/verify-otp"
              element={<AddPolicyOTP />}
            />
            <Route
              path="/add-policy/card-number/review-details"
              element={<ReviewCard />}
            />
            <Route
              path="/add-policy/card-number/success"
              element={<PolicySuccess />}
            />
            <Route path="/add-policy/details" element={<PoliciesDetails />} />
          </Route>
          <Route path="/my-account" element={<MyAccountIndex />}>
            <Route
              index
              element={
                <>
                  <SideDrawer>
                    <MyAccount />
                  </SideDrawer>
                  <BottomNavBar />
                </>
              }
            />
            <Route
              path="/my-account/update-details"
              element={<UpdateDetails />}
            />
            <Route
              path="/my-account/update-details/otp"
              element={<UpdateDetailsOTP />}
            />
            <Route
              path="/my-account/update-details/success"
              element={<UpdateDetailsSuccess />}
            />
          </Route>
          {/*MVP 1.2 ROUTES*/}
          <Route
            path="/transaction-history"
            element={<TransactionHistoryIndex />}
          >
            <Route index element={<TransactionHistory />} />
          </Route>
          <Route path="/book-service" element={<BookServiceIndex />}>
            <Route
              index
              element={
                <>
                  <SideDrawer>
                    <BookService />
                  </SideDrawer>
                  <BottomNavBar />
                </>
              }
            />
          </Route>

          {/*MVP 1.3 ROUTES*/}
          <Route path="/teleconsult-voice" element={<Teleconsult />}>
            <Route index element={<BookService />} />
            <Route
              path="/teleconsult-voice/instructions"
              element={<TeleconsultInstructions />}
            />
            <Route
              path="/teleconsult-voice/landline-number"
              element={<TeleconsultLandlineNumber />}
            />
          </Route>

          <Route path="/notification" element={<Notification />}>
            <Route index element={<NotificationList />} />
            <Route
              path="/notification/details"
              element={<NotificationDetails />}
            />
          </Route>

          <Route
            path="/loa-reimbursement-services"
            element={<LOAReimbursementIndex />}
          >
            <Route index element={<LOAReimbursement />} />
            <Route
              path="/loa-reimbursement-services/loa-reimbursement-providers"
              element={<LOAReimbursement />}
            />
            <Route
              path="/loa-reimbursement-services/consultation-loa-request"
              element={<LoaConsultIndex />}
            >
              <Route index element={<LoaConsult />} />
            </Route>
            <Route
              path="/loa-reimbursement-services/medical-test-loa-request"
              element={<LoaMedicalTestIndex />}
            >
              <Route index element={<LoaMedicalTest />} />
            </Route>
            <Route
              path="/loa-reimbursement-services/reimbursement-request"
              element={<ReimbursementRequestIndex />}
            >
              <Route index element={<ReimbursementRequest />} />
            </Route>
          </Route>

          <Route path="/verification" element={<VerificationIndex />}>
            <Route index element={<Verification />} />
          </Route>
          <Route path="/verify-email" element={<VerifyEmailIndex />}>
            <Route index element={<VerifyEmail />} />
          </Route>
        </Routes>
      )}
    </>
  );
};

export default App;
